module.exports = __webpack_public_path__ + "static/media/DSC03586.37351821.JPG";